import { FullPageLoaderOverlay } from '@/components/Layout/FullPageLoader.tsx';

import { getAssetPath } from '@/constants/configs';

import { Page, PageProps } from './Page';

type PageWithRightImageProps = {
  loading?: boolean;
} & Partial<PageProps>;

export function PageWithRightImage({
  children,
  paperProps,
  loading = false,
  ...restPageProps
}: PageWithRightImageProps) {
  return (
    <>
      {loading && <FullPageLoaderOverlay />}
      <Page
        paperProps={{
          position: 'right',
          size: 'big',
          bgImg: getAssetPath('/bg-register.png'),
          color: theme => theme.palette.overlay.darkBlue.start,
          secondColor: theme => theme.palette.overlay.darkBlue.end,
          hasLogo: true,
          ...paperProps,
        }}
        {...restPageProps}
      >
        {children}
      </Page>
    </>
  );
}
